import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
import { endPoint } from "constants/server/api";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllBranchByAdPointSlice = createSlice({
    name: "getAllBranchByAdPoint",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllBranchByAdPointSlice_actions = getAllBranchByAdPointSlice.actions;
export var fetchData = _getAllBranchByAdPointSlice_actions.fetchData, fetchDataSuccess = _getAllBranchByAdPointSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllBranchByAdPointSlice_actions.fetchDataFailure, resetState = _getAllBranchByAdPointSlice_actions.resetState;
export default getAllBranchByAdPointSlice.reducer;
